import { styled } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

export const HeadControls = styled("div")(
  ({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(2),
  }));

export const Header = styled("section")(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(1),
    position: "sticky",
    top: "0px",
    zIndex: 10,
  }));

export const TabsContainer = styled(Tabs)(
  ({ theme }) => ({
    "&.MuiTabs-root": {
      overflow: "hidden",
      "& .MuiTabs-scroller": {
        paddingTop: theme.spacing(0.5),
      },
    },
  }));

export const Content = styled("section")(
  () => ({
    alignItems: 'center',
    display: "flex",
    flex: 1,
    flexDirection: "row",
    height: '100%',
    minHeight: '25rem',
    width: '72rem'
  }));

export const TabContent = styled("section")(
  ({ theme }) => ({
    alignItems: "stretch",
    flexDirection: "column",
    display: "flex",
    flex: 1,
    margin: theme.spacing(
      2,
      0
    ),
    overflow: "visible",
    width: "100%",
  }));

export const ActionsContainer = styled("section")(
  ({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.default,
    bottom: "0px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingBottom: theme.spacing(2.5),
    position: "sticky",
    width: "100%",
    zIndex: 10,
  }));

export const SecondaryActions = styled("section")(
  ({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    width: "100%",
  }));

export const DialogTab = styled(Tab)(
  () => ({
    "&.MuiTab-root": {
      overflow: "visible",
    },
  }));

export const MessageButtons = styled("section")(
  ({ theme }) => ({
    alignContent: "center",
    marginLeft: theme.spacing(2),
  }));

export const ButtonContainer = styled("div")(
  () => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  }));

export const MessageButton = styled(IconButton)(
  () => ({
    paddingBottom: 0,
  }));

export const MessageButtonLabel = styled(Typography)(
  () => ({
    fontSize: "0.6em",
  }));
